import script from "./PopupPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./PopupPreview.vue?vue&type=script&setup=true&lang=js"

import "./PopupPreview.vue?vue&type=style&index=0&id=6b734473&scoped=true&lang=css"

import exportComponent from "/home/dragos/Work/cozmoslabs-ddev/translatepress/wp-content/plugins/translatepress/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b734473"]])

export default __exports__